module.exports = __webpack_public_path__ + "img/checked-white.6ef9e7f1.svg";